import { Component } from "@angular/core";
import { Router } from "@angular/router";

import { SearchResultType, SearchType } from "@common/plants.enums";

import { Plant } from "@models/Plant";
import { SearchCriteria } from "@models/SearchCriteria";
import { TopLevelSearchResult } from "@models/TopLevelSearchResult";

import { FetchService } from "@services/fetch.service";
import { SearchService } from "@services/search.service";

import { AppConfig } from "../app.config";

@Component({
  standalone: true,
  selector: "factsheet-plantguide-search",
  template: `<a
    href="javascript:void(0)"
    tabIndex="0"
    class="usa-link"
    (click)="performSearch()"
    (keyup.enter)="performSearch()"
    ><span>Fact Sheets/Plant Guides</span></a
  >`
})
export class FactSheetPlantGuideSearchComponent {
  results: Plant[] = [];
  featureFlags: { [key: string]: boolean } = {};

  constructor(
    private appConfig: AppConfig,
    private fetchService: FetchService,
    private searchService: SearchService,
    private router: Router
  ) {
    this.featureFlags = this.appConfig.getFeatureFlags();
  }

  performSearch(): void {
    // reset results
    this.results = [];

    const searchCriteria = new SearchCriteria(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      "sortSciName",
      -1,
      null,
      null,
      "FactSheetPlantGuide",
      null,
      -1
    );
    this.searchService.searchCriteria = searchCriteria;

    this.searchService.updateSearchStatus(true);

    this.fetchService
      .fetchPlantsSearchResults(
        {
          ...searchCriteria,
          Type: SearchResultType.FactSheetPlantGuide
        },
        1
      )
      .then(this.displayResults.bind(this))
      .catch(this.displayResults.bind(this));
  }

  handleError(): void {
    this.searchService.updateSearchStatus(false);

    this.router.navigate(["/fact-sheet-plant-guide-search-results"]);
  }

  displayResults(result: TopLevelSearchResult): void {
    this.router
      .navigate(["/fact-sheet-plant-guide-search-results"], {
        queryParams: { resultId: result.ResultId }
      })
      .then(() => {
        this.searchService.searchType = SearchType.FactSheetPlantGuideSearch;
        this.searchService.updateSearchStatus(false);

        this.searchService.result = result;

        if (!this.searchService.criteriaHistory.has(result.ResultId)) {
          this.searchService.criteriaHistory.set(
            result.ResultId,
            this.searchService.searchCriteria
          );
        }

        if (!this.searchService.searchTypeHistory.has(result.ResultId)) {
          this.searchService.searchTypeHistory.set(result.ResultId, this.searchService.searchType);
        }

        if (
          this.searchService.resultHistory.filter((r) => r.ResultId === result.ResultId).length ===
          0
        ) {
          this.searchService.resultHistory.push(result);
        }
      });
  }
}
